<app-user-public-profile-assigned-forms *ngIf="employeeService?.employee?.hash" [hash]="employeeService?.employee?.hash"></app-user-public-profile-assigned-forms>
